export const MenuItems = [
    {
        title: 'Home',
        url: '/',
        cName: 'nav-links'
    },
    {
        title: 'About',
        url: '/about',
        cName: 'nav-links'
    },
    {
        title: 'Services',
        url: '/services',
        cName: 'nav-links'
    },
    {
        title: 'Products',
        url: '/products',
        cName: 'nav-links'
    },
    {
        title: 'Contact Us',
        url: '/contact-us',
        cName: 'nav-links'
    },
    {
        title: 'Sign Up',
        url: 'sign-up',
        cName: 'nav-links-mobile'
    }
]